import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { FoundationAutocompleteDirectivesModule } from '../directives/autocomplete/autocomplete-directives.module';
import { FoundationHighlightPipeModule } from '../pipes/highlight/foundation-highlight-pipe.module';

import { FoundationPracticeSelectComponent } from './practice-select.component';

@NgModule({
    declarations: [ FoundationPracticeSelectComponent ],
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        MatAutocompleteModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        MatIconModule,
        MatButtonModule,
        FoundationHighlightPipeModule,
        FoundationAutocompleteDirectivesModule
    ],
    exports: [ FoundationPracticeSelectComponent ]
})
export class FoundationPracticeSelectModule {}
